module.exports = __webpack_public_path__ + "img/affiche.152f5e9e.png";